module.exports = __webpack_public_path__ + "img/r1@2x.b8511a52.png";